<template lang="pug">
.dashboard-wrapper
  b-row
    b-col
      b-card(no-body, class="pt-2 px-2")
        filters(
          :customFiltersShow="true"
          :zoneFilterShow="zone_agency_filter"
          :agencyFilterShow="zone_agency_filter"
          :locationFilterShow="true",
          :roleFilterShow="true",
          :processFilterShow="true",
          :supervisorFilterShow="true",
          :dateRangeFilterShow="true",
          :locationDefaultValue="true",
          :physicalLocationFilterShow="true"
          :areaFilterShow="true"
          @changeFilter="updateFilter",
          @supervisors="updateSupervisors"
        )
  
  b-row(v-if="isLoading")
    b-col
      b-card(class="py-5")
        loading(
          :active="true" 
          :is-full-page="false"
          :color="colors.primary"
        )

  div(v-else)
    b-row(v-if="!qEvents")
      b-col
        b-card(class="text-center")
          h5(class="mb-0")
            | {{ $t('message.no_events_found') }}

    div(v-else)
      b-row
        b-col(md="6")
          support-tracker(v-if="trackerData.total", :tracker-data="trackerData")
        b-col(md="6")
          bar-chart-progress(v-if="trackerData.total", :progress-data="progressCompliance")
      
      //- b-row
        b-col(cols="12")
          revenue-report(
            v-if="globalCompliance.labels && globalCompliance.labels.length",
            :location-data="globalCompliance"
          )

      b-row
        b-col(cols="12")
          bar-chart-compliance(
            v-if="locationCompliance.labels && locationCompliance.labels.length",
            :compliance-data="locationCompliance"
          )

      b-row
        b-col(cols="12")
          bar-chart-compliance-process(
            v-if="processCompliance.labels && processCompliance.labels.length",
            :compliance-data="processCompliance"
          )

      //- b-row
        b-col(
          md="6",
          v-for="(location, name, index) in locationCompliance",
          :key="index"
        )
          earnings-chart(:location-data="location")

      b-card
        b-table-simple(hover, small, caption-top, responsive)
          b-thead(head-variant="light")
            b-tr
              th {{ $t('message.tableHeader.physical_locations') }}
              th {{ $t('message.tableHeader.locations') }}
              th {{ $t('message.tableHeader.supervisor') }}
              th {{ $t('message.tableHeader.observed') }}
              th {{ $t('message.tableHeader.cumplimiento') }}
              th {{ $t('message.tableHeader.completed') }}
              th {{ $t('message.tableHeader.pending') }}
              th {{ $t('message.tableHeader.overdue') }}
            b-tr(v-for="(supervisor, index) of supervisors", :key="index")
              b-td {{ supervisor.physical_locations || '-' }}
              b-td {{ supervisor.location }}
              b-td {{ supervisor.supervisor }}
              b-td {{ supervisor.observed }}
              b-td {{ supervisor.compliance }}
              b-td {{ supervisor.done }}
              b-td {{ supervisor.pending }}
              b-td {{ supervisor.overdue }}
      b-row
        b-col(md="4")
          b-button(class="mb-1 w-100", :disabled="!supervisors.length")
              json-excel(:data="supervisors", :fields="supervisorFields")
                | {{ $t('download_xlsx_compliance') }}
        b-col(md="4")
          b-button(class="mb-1 w-100", :disabled="!confirmations.length")
              json-excel(:data="confirmations", :fields="confirmationFields")
                | {{ $t('download_xlsx_confirmations') }}
        b-col(md="4")
          b-button(class="mb-1 w-100", :disabled="!deletedEvents.length")
              json-excel(:data="deletedEvents", :fields="deletedEventsFields")
                | {{ $t('download_xlsx_deleted_confirmations') }}
</template>

<script>
import { onMounted, ref, computed } from "@vue/composition-api/dist/vue-composition-api"
import useNotifications from "@/composables/useNotifications";
import { BTable, BTableSimple, BThead, BTr, BTd, BCard } from "bootstrap-vue"
import JsonExcel from "vue-json-excel"
import SupportTracker from "../charts/CardAnalyticSupportTracker.vue"
import BarChartProgress from '../charts/ChartjsHorizontalBarChartProgress.vue'
// import EarningsChart from "../charts/CardAnalyticEarningsChart.vue";
// import RevenueReport from "../charts/CardAnalyticRevenueReport.vue";
import BarChartCompliance from '../charts/ChartjsBarChartCompliance.vue'
import BarChartComplianceProcess from '../charts/ChartjsBarChartComplianceProcess.vue'
import Filters from "@/views/organization/Filters.vue"
import i18n from '@/libs/i18n'
import useCommonDashboards from '@/views/habit/useCommonDashboards'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import store from "@/store"
import useCommon from '@/views/organization/useCommon'
import { get } from 'idb-keyval'
import { colors } from '@/constants'
import { useLambda } from '@/views/habit/awsLambda'
import { oid, date } from '@/helpers/mongoHelpers'

export default {
  components: {
    BTable,
    BTableSimple,
    BThead,
    BTr,
    BTd,
    BCard,
    JsonExcel,
    SupportTracker,
    BarChartProgress,
    // EarningsChart,
    // RevenueReport,
    BarChartCompliance,
    BarChartComplianceProcess,
    Filters,
    Loading,
  },
  setup() {
    const userData = store.state?.userStore?.userData;
    const clientId = userData.role !== "admin" ? userData.client.$oid : null;
    const userLocations = userData.locations?.length ? userData.locations : null;
    const { handleError } = useCommon()
    const { getItemsAggregate } = useLambda()
    const qEvents = ref(0)
    const confirmations = ref([]);
    const supervisors = ref([]);
    const deletedEvents = ref([])
    const globalCompliance = ref({});
    const locationCompliance = ref({});
    const processCompliance = ref({});
    const progressCompliance = ref({});
    const trackerData = ref({});
    const locationFilter = ref(userLocations ? userLocations.map(e => e.value) : []);
    const physicalLocationFilter = ref([])
    const roleFilter = ref([]);
    const processFilter = ref([]);
    const supervisorFilter = ref([]);
    const zoneFilter = ref([]);
    const agencyFilter = ref([]);
    const supervisorsDropdown = ref([])
    get('supervisors').then(response => {
      if (response) supervisorsDropdown.value = response
      else if (localStorage.supervisors) supervisorsDropdown.value = JSON.parse(localStorage.supervisors)
    })
    const now = new Date()
    const currentMonth = now.getMonth()
    const currentYear = now.getFullYear()
    const lastDayOfMonthDate = new Date(currentYear, currentMonth + 1, 0)
    const lastDayOfMonthNumber = lastDayOfMonthDate.getDate()
    const dateRangeFilter = ref(`01-${currentMonth + 1}-${currentYear} to ${lastDayOfMonthNumber}-${currentMonth + 1}-${currentYear}`)
    const confirmationFields = ref({})
    const isLoading = ref(true)
    const { zone_agency_filter, default_language } = JSON.parse(localStorage.getItem('clientData') || '{}')
    const supervisorFields = ref({
      [i18n.t('message.tableHeader.supervisor')]: "supervisor",
      [i18n.t('message.tableHeader.location')]: "location",
      [i18n.t('message.tableHeader.physical_location')]: "physical_locations",
      [i18n.t('message.tableHeader.cumplimiento')]: "compliance",
      [i18n.t('message.tableHeader.completed')]: "done",
      [i18n.t('message.tableHeader.pending')]: "pending",
      [i18n.t('message.tableHeader.overdue')]: "overdue",
      [i18n.t('message.tableHeader.observed')]: "observed",
    })
    const deletedEventsFields = ref({
      [i18n.t('message.tableHeader.date')]: "startString",
      [i18n.t('message.tableHeader.worker')]: "worker",
      [i18n.t('message.tableHeader.location')]: "location",
      [i18n.t('message.tableHeader.physical_location')]: "physicalLocation",
      [i18n.t('message.tableHeader.process')]: "process",
      [i18n.t('message.tableHeader.status')]: "status",
      [i18n.t('message.tableHeader.deletedBy')]: "deletedBy",
      [i18n.t('message.tableHeader.deletedJustification')]: "deletedJustification",
      [i18n.t('message.tableHeader.id')]: "id",
    })
    const { processAdherence, getDatesFromRange, dateDiffInDays, getLocationLabel } = useCommonDashboards()

    async function listConfirmations() {
      isLoading.value = true
      const [startFilter, endFilter] = getDatesFromRange(dateRangeFilter.value)

      try {
        // Validate clientId before creating ObjectId
        if (!clientId) {
          console.error('clientId is null or undefined')
          handleError({ error: new Error('Client ID is required'), defaultMessage: i18n.t('message.err_confirmation_list') })
          isLoading.value = false
          return
        }

        const initialQuery = {
          client_id: oid(clientId),
          'extendedProps.calendar': { $in: ["Pendientes", "Realizadas", "Vencidas"] },
          start: { $gte: date(startFilter), $lt: date(endFilter) },
          isBehaviourEvaluation: { $ne: true }
        }

        if (Array.isArray(processFilter.value) && processFilter.value.length > 0) {
          initialQuery.process = { $in: processFilter.value.map(e => oid(e)) }
        }

        const finalQuery = {
          $or: [
            { "attendee.deleted": { $ne: true } },
            { "attendee.deleted": true, 'extendedProps.calendar': "Realizadas" },
            { attendee: null }
          ]
        }

        if (Array.isArray(roleFilter.value) && roleFilter.value.length > 0) {
          finalQuery["attendee.roles"] = { $in: roleFilter.value.map(e => oid(e)) }
        }

        if (Array.isArray(supervisorFilter.value) && supervisorFilter.value.length > 0) {
          finalQuery["attendee.supervisors._id"] = { $in: supervisorFilter.value }
        }

        if (Array.isArray(locationFilter.value) && locationFilter.value.length > 0) {
          finalQuery.$or[0]['attendee.locations._id'] = { $in: locationFilter.value }
          finalQuery.$or[1]['attendee.locations._id'] = { $in: locationFilter.value }
          finalQuery.$or[2]['organizer.locations._id'] = { $in: locationFilter.value }
        }

        if (Array.isArray(physicalLocationFilter.value) && physicalLocationFilter.value.length > 0) {
          finalQuery.$or[0]['attendee.physical_locations._id'] = { $in: physicalLocationFilter.value }
          finalQuery.$or[1]['attendee.physical_locations._id'] = { $in: physicalLocationFilter.value }
          finalQuery.$or[2]['organizer.physical_locations._id'] = { $in: physicalLocationFilter.value }
        }

        if (Array.isArray(zoneFilter.value) && zoneFilter.value.length > 0) {
          finalQuery.$or[0]['attendee.locations.zone'] = { $in: zoneFilter.value }
          finalQuery.$or[1]['attendee.locations.zone'] = { $in: zoneFilter.value }
          finalQuery.$or[2]['organizer.locations.zone'] = { $in: zoneFilter.value }
        }

        if (Array.isArray(agencyFilter.value) && agencyFilter.value.length > 0) {
          finalQuery.$or[0]['attendee.locations.agency'] = { $in: agencyFilter.value }
          finalQuery.$or[1]['attendee.locations.agency'] = { $in: agencyFilter.value }
          finalQuery.$or[2]['organizer.locations.agency'] = { $in: agencyFilter.value }
        }

        const pipeline = [
          { $match: initialQuery },
          { $lookup: { from: 'worker', localField: 'attendee', foreignField: '_id', as: 'attendee', pipeline: [ { $project: { deleted: 1, supervisors: 1, name: 1, locations: 1, roles: 1, physical_locations: 1 } }, { $addFields: { _id: { $toString: "$_id" } } }, { $lookup: { from: 'worker', localField: 'supervisors', foreignField: '_id', as: 'supervisors', pipeline: [ { $project: { name: 1, locations: 1, physical_locations: 1 } }, { $addFields: { _id: { $toString: "$_id" } } }, { $lookup: { from: 'location', localField: 'locations', foreignField: '_id', as: 'locations', pipeline: [ { $project: { location: 1 } }, { $addFields: { _id: { $toString: "$_id" } } } ] } }, { $lookup: { from: 'physical_location', localField: 'physical_locations', foreignField: '_id',  as: 'physical_locations', pipeline: [ { $project: { name: 1 } }, { $addFields: { _id: { $toString: "$_id" } } } ] } } ] } }, { $lookup: { from: 'location', localField: 'locations', foreignField: '_id', as: 'locations', pipeline: [ { $project: { location: 1, zone: 1, agency: 1, physical_location: 1 } }, { $lookup: { from: 'physical_location', localField: 'physical_location', foreignField: '_id', as: 'physical_location', pipeline: [ { $project: { name: 1 } } ] } }, { $addFields: { _id: { $toString: "$_id" }, physical_location: { $arrayElemAt: ["$physical_location.name", 0] } } } ] } }, { $lookup: { from: 'physical_location', localField: 'physical_locations', foreignField: '_id',  as: 'physical_locations', pipeline: [ { $project: { name: 1 } }, { $addFields: { _id: { $toString: "$_id" } } } ] } } ] } },
          { $lookup: { from: 'worker', localField: 'organizer', foreignField: '_id', as: 'organizer', pipeline: [ { $project: { name: 1, locations: 1, physical_locations: 1 } }, { $addFields: { _id: { $toString: "$_id" } } }, { $lookup: { from: 'location', localField: 'locations', foreignField: '_id', as: 'locations', pipeline: [ { $project: { location: 1, zone: 1, agency: 1, physical_location: 1 } }, { $lookup: { from: 'physical_location', localField: 'physical_location', foreignField: '_id', as: 'physical_location', pipeline: [ { $project: { name: 1 } } ] } }, { $addFields: { _id: { $toString: "$_id" }, physical_location: { $arrayElemAt: ["$physical_location.name", 0] } } } ] } }, { $lookup: { from: 'physical_location', localField: 'physical_locations', foreignField: '_id',  as: 'physical_locations', pipeline: [ { $project: { name: 1 } }, { $addFields: { _id: { $toString: "$_id" } } } ] } } ] } },
          { $addFields: { attendee: { $arrayElemAt: ["$attendee", 0] }, organizer: { $arrayElemAt: ["$organizer", 0] } } },
          { $match: finalQuery },
          { $lookup: { from: 'process', localField: 'process', foreignField: '_id', as: 'process', pipeline: [ { $project: { name: 1 } }, { $addFields: { _id: { $toString: "$_id" } } } ] } },
          { $lookup: { from: 'confirmation', localField: 'confirmation', foreignField: '_id', as: 'confirmation', pipeline: [ { $addFields: { _id: { $toString: "$_id" } } }, { $lookup: { from: 'worker', localField: 'supervisor', foreignField: '_id', as: 'supervisor', pipeline: [ { $project: { name: 1, locations: 1, physical_locations: 1 } }, { $addFields: { _id: { $toString: "$_id" } } }, { $lookup: { from: 'location', localField: 'locations', foreignField: '_id', as: 'locations', pipeline: [ { $project: { location: 1 } }, { $addFields: { _id: { $toString: "$_id" } } } ] } }, { $lookup: { from: 'physical_location', localField: 'physical_locations', foreignField: '_id',  as: 'physical_locations', pipeline: [ { $project: { name: 1 } }, { $addFields: { _id: { $toString: "$_id" } } } ] } }] } }, { $addFields: { supervisor: { $arrayElemAt: ["$supervisor", 0] } } } ] } },
          { $lookup: { from: 'worker', localField: 'deletedBy', foreignField: '_id', as: 'deletedBy', pipeline: [ { $project: { name: 1 } }, { $addFields: { _id: { $toString: "$_id" } } } ] } },
          { $addFields: { _id: { $toString: "$_id" }, process: { $arrayElemAt: ["$process", 0] }, confirmation: { $arrayElemAt: ["$confirmation", 0] }, deletedBy: { $arrayElemAt: ["$deletedBy", 0] } } },
        ]

        const items = await getItemsAggregate({ collection: 'event', pipeline })

        qEvents.value = items?.length || 0
        parseConfirmationData(items)
        parseSupervisorData(items, startFilter, endFilter)
      } catch (error) {
        console.log(error)
        handleError({ error, defaultMessage: i18n.t('message.err_confirmation_list') })
      } finally {
        isLoading.value = false
      }
    }

    // Data for adherence XLSX File
    function parseConfirmationData(items) {
      confirmationFields.value = {
        [i18n.t('message.tableHeader.date')]: "date",
        [i18n.t('message.tableHeader.worker')]: "worker",
        [i18n.t('message.tableHeader.observer')]: "observer",
        [i18n.t('message.tableHeader.location')]: "location",
        [i18n.t('message.tableHeader.physical_location')]: "physical_location",
        [i18n.t('message.tableHeader.process')]: "process",
        [i18n.t('message.tableHeader.score')]: "score",
        [i18n.t('message.tableHeader.total')]: "total",
        [i18n.t('message.tableHeader.adherence')]: "adherence",
        [i18n.t('message.tableHeader.duration')]: "duration",
        [i18n.t('label.processStart')]: "processStart",
        [i18n.t('label.processEnd')]: "processEnd",
        [i18n.t('label.processDuration')]: "processDuration",
      }
      let confirmations_data = []
      let textBehaviourColumns = [] // Array to store unique text behaviour names in order
      if (!Array.isArray(items)) {
        confirmations.value = confirmations_data
        return
      }
      for (const event of items) {
        if (event.confirmation && !event.confirmation.pending && event.confirmation.total) {
          // Collect all text-type behaviors from all activities in order
          const textBehaviours = []
          if (event?.confirmation?.activities) {
            for (const activity of event.confirmation.activities) {
              if (activity?.behaviours) {
                for (const behaviour of activity.behaviours) {
                  if (behaviour.type === "text") {
                    const behaviourName = stripHtmlTags(behaviour.name || 'Comentario')
                    textBehaviours.push({
                      name: behaviourName,
                      answer: behaviour.answer || ''
                    })

                    // Add to global columns list if not already present
                    if (!textBehaviourColumns.includes(behaviourName)) {
                      textBehaviourColumns.push(behaviourName)
                    }
                  }
                }
              }
            }
          }

          const confirmationDate = event.confirmation.date ? new Date(event.confirmation.date) : null
          let payload = {
            date: confirmationDate?.toLocaleDateString(`${default_language || 'en'}-US`) || '',
            worker: event.attendee?.name,
            observer: event.confirmation.supervisor?.name,
            location: event.attendee?.locations?.map(e => e.location).join(" / "),
            physical_location: event.attendee?.physical_locations?.map(e => e.name).join(" / "),
            process: event.process?.name,
            score: event.confirmation.score,
            total: event.confirmation.total,
            adherence: processAdherence(event.confirmation.score, event.confirmation.total),
            duration: event.confirmation.duration,
            id: event.confirmation._id,
            processStart: event.confirmation.processStart,
            processEnd: event.confirmation.processEnd,
            processDuration: event.confirmation.processDuration,
          }

          // Add text behaviors as separate columns using their names as keys
          textBehaviours.forEach((textBehaviour) => {
            payload[textBehaviour.name] = textBehaviour.answer
          })

          // Add metadata fields if applicable
          if (event.confirmation.metadata) {
            event.confirmation.metadata.forEach(e => {
              payload[e.name] = e.answer
              if (!confirmationFields.value.hasOwnProperty(i18n.t(`metadata.${e.name}`))) {
                confirmationFields.value[i18n.t(`metadata.${e.name}`)] = e.name
              }
            })
          }
          confirmations_data.push(payload);
        }
      }
      confirmations_data.sort(function (a, b) {
        if (b.score === 0 && a.score === 0) return a.total - b.total
        return b.adherence - a.adherence
      })
      confirmations.value = confirmations_data

      // Add dynamic text behaviour columns to confirmationFields using their names
      textBehaviourColumns.forEach((columnName) => {
        confirmationFields.value[columnName] = columnName
      })

      confirmationFields.value[i18n.t('message.tableHeader.id')] = "id"
    }

    // Data for supervisors compliance table
    function parseSupervisorData(items, startFilter, endFilter) {
      let supervisorData = {};
      let _globalCompliance = { Realizadas: 0, Vencidas: 0, Pendientes: 0 };
      let _locationCompliance = {};
      let _processCompliance = {};
      let deletedEventsData = []

      if (!Array.isArray(items)) {
        supervisors.value = []
        deletedEvents.value = []
        return
      }

      // TODO: change the supervisor from "organizer" to array of supervisord from atendee.
      for (const element of items) {
        const status = element.extendedProps?.calendar;
        const eventLocations = element.attendee ? element.attendee.locations : element.organizer?.locations
        const eventPhysicalLocations = element.attendee
          ? (element.attendee.physical_locations || [])
          : (element.organizer?.physical_locations || [])

        if (element.deleted) {
          const eventStart = new Date(element.start)
          deletedEventsData.push({
            start: eventStart,
            startString: eventStart?.toLocaleDateString(`${default_language || 'en'}-US`) || '',
            process: element.process?.name,
            worker: element.attendee?.name,
            location: eventLocations?.map(e => e.location).join(" / "),
            physicalLocation: eventPhysicalLocations ? eventPhysicalLocations.map(e => e.name).join(" / ") : [],
            status: status,
            deletedBy: element.deletedBy?.name,
            deletedJustification: element.deletedJustification,
            id: element._id,
          })
          continue
        }

        if (status === "Realizadas") _globalCompliance["Realizadas"] += 1;
        else if (status === "Pendientes") _globalCompliance["Pendientes"] += 1;
        else if (status === "Vencidas") _globalCompliance["Vencidas"] += 1;

        const processName = element.process?.name
        if (processName) {
          if (!_processCompliance[processName]) {
            _processCompliance[processName] = {
              done: 0,
              pending: 0,
              overdue: 0,
              id: element.process?._id
            };
          }

          if (status === "Realizadas") _processCompliance[processName]["done"] += 1;
          else if (status === "Pendientes") _processCompliance[processName]["pending"] += 1;
          else if (status === "Vencidas") _processCompliance[processName]["overdue"] += 1;
        }

        if (!Array.isArray(eventLocations)) continue;

        for (const location of eventLocations) {
          if (locationFilter.value.length && !locationFilter.value.includes(location._id)) continue
          const locationLabel = getLocationLabel(location)
          if (!_locationCompliance[locationLabel]) {
            _locationCompliance[locationLabel] = {
              done: 0,
              pending: 0,
              overdue: 0,
              id: location._id
            };
          }

          if (status === "Realizadas") _locationCompliance[locationLabel]["done"] += 1;
          else if (status === "Pendientes") _locationCompliance[locationLabel]["pending"] += 1;
          else if (status === "Vencidas") _locationCompliance[locationLabel]["overdue"] += 1;
        }

        // Iterate supervisors
        // If the event has an attendee, iterate over its supervisors
        // Else iterate over the list of supervisors and see who has the same location as the event organizer
        if (element.attendee) {
          if (supervisorFilter.value.length) {
            supervisorFilter.value.forEach(s => {
              const supervisorFound = Array.isArray(element.attendee.supervisors)
                ? element.attendee.supervisors.find(e => e._id === s)
                : null
              if (supervisorFound) {
                const name = supervisorFound.name
                const supervisorLocations = supervisorFound.locations?.map(e => e.location).join(" / ")
                const supervisorPhysicalLocations = supervisorFound.physical_locations ? supervisorFound.physical_locations.map(e => e.name).join(" / ") : []
                updateSupervisorData(supervisorData, name, supervisorLocations, status, supervisorPhysicalLocations)
              }
            })
          } else if (Array.isArray(element.attendee.supervisors)) {
            for (const supervisor of element.attendee.supervisors) {
              const name = supervisor.name
              const supervisorLocations = supervisor.locations?.map(e => e.location).join(" / ")
              const supervisorPhysicalLocations = supervisor.physical_locations ? supervisor.physical_locations.map(e => e.name).join(" / ") : []
              updateSupervisorData(supervisorData, name, supervisorLocations, status, supervisorPhysicalLocations)
            }
          }
        } else if (Array.isArray(eventLocations)) {
          if (supervisorFilter.value.length) {
            supervisorFilter.value.forEach(s => {
              const supervisorFound = Array.isArray(supervisorsDropdown.value)
                ? supervisorsDropdown.value.find(e => e.value === s)
                : null
              if (supervisorFound) {
                const supervisorLocationIds = supervisorFound.locationIds
                for (const location of eventLocations) {
                  if (locationFilter.value.length && !locationFilter.value.includes(location._id)) continue
                  if (Array.isArray(supervisorLocationIds) && supervisorLocationIds.includes(location._id)) {
                    const name = supervisorFound.title
                    const supervisorLocationNames = supervisorFound.locationNames?.join(" / ")
                    updateSupervisorData(supervisorData, name, supervisorLocationNames, status, [])
                    break
                  }
                }
              }
            })
          } else if (Array.isArray(supervisorsDropdown.value)) {
            for (const supervisor of supervisorsDropdown.value) {
              const supervisorLocationIds = supervisor.locationIds
              if (Array.isArray(supervisorLocationIds)) {
                for (const location of eventLocations) {
                  if (locationFilter.value.length && !locationFilter.value.includes(location._id)) continue
                  if (supervisorLocationIds.includes(location._id)) {
                    const name = supervisor.title
                    const supervisorLocationNames = supervisor.locationNames?.join(" / ")
                    updateSupervisorData(supervisorData, name, supervisorLocationNames, status, [])
                    break
                  }
                }
              }
            }
          }
        }

        // Update supervisors 'observed' property for events with confirmations
        if (element.confirmation && element.confirmation.supervisor) {
          if (supervisorFilter.value.length && !supervisorFilter.value.includes(element.confirmation.supervisor._id)) continue
          const name = element.confirmation.supervisor.name
          const supervisorLocations = element.confirmation.supervisor.locations?.map(e => e.location).join(" / ")
          const supervisorPhysicalLocations = element.confirmation.supervisor.physical_locations ? element.confirmation.supervisor.physical_locations.map(e => e.name).join(" / ") : []
          updateSupervisorData(supervisorData, name, supervisorLocations, "Observadas", supervisorPhysicalLocations)
        }
      }

      // Set deleted events data for Excel download
      deletedEventsData.sort(function (a, b) {
        return a.start - b.start
      })
      deletedEvents.value = deletedEventsData

      // Parse supervisor data for Excel download
      let supervisorDataExcel = []

      for (const supervisor in supervisorData) {
        supervisorDataExcel.push({
          supervisor: supervisor,
          location: supervisorData[supervisor].location,
          physical_locations: supervisorData[supervisor].physicalLocations ? supervisorData[supervisor].physicalLocations : '-',
          compliance: compliance(supervisorData[supervisor]),
          done: supervisorData[supervisor].Realizadas,
          pending: supervisorData[supervisor].Pendientes,
          overdue: supervisorData[supervisor].Vencidas,
          observed: supervisorData[supervisor].Observadas,
        })
      }

      supervisorDataExcel.sort(function (a, b) {
        if (b.observed !== a.observed) return b.observed - a.observed
        if (b.overdue !== a.overdue) return b.overdue - a.overdue
        if (b.pending !== a.pending) return b.pending - a.pending
        return a.done - b.done
      })

      supervisors.value = supervisorDataExcel;
      
      // Set tracker data
      trackerData.value = {
        title: computed(() => i18n.t("Cumplimiento")),
        lastDays: ["Acumulado"],
        total:
          _globalCompliance.Pendientes +
          _globalCompliance.Realizadas +
          _globalCompliance.Vencidas,
        done: _globalCompliance.Realizadas,
        pending: _globalCompliance.Pendientes,
        overdue: _globalCompliance.Vencidas,
      };

      // Set progress bar data
      const actualProgress = trackerData.value.total
        ? Math.round(trackerData.value.done / trackerData.value.total * 100)
        : 0

      const theoreticalProgress = endFilter < now
        ? 100
        : startFilter > now
          ? 0
          : Math.round(dateDiffInDays(startFilter, now) / dateDiffInDays(startFilter, endFilter) * 100)

      progressCompliance.value = {
        actual: actualProgress,
        theoretical: theoreticalProgress,
      }

      // Set location compliance data
      for (const location in _locationCompliance) {
        _locationCompliance[location].total = _locationCompliance[location].done + _locationCompliance[location].pending + _locationCompliance[location].overdue
        _locationCompliance[location].compliance = _locationCompliance[location].total ? Math.round(_locationCompliance[location].done / _locationCompliance[location].total * 1000) / 10 : 0
      }

      let locationComplianceDataSorted = Object.entries(_locationCompliance)

      locationComplianceDataSorted.sort(function (a, b) {
        if (b[1].compliance === 0 && a[1].compliance === 0) return a[1].total - b[1].total
        return b[1].compliance - a[1].compliance
      })

      let locationComplianceLabels = []
      let locationComplianceValues = []
      let locationComplianceValuesDone = []
      let locationComplianceValuesPending = []
      let locationComplianceValuesOverdue = []
      let locationComplianceValuesPendingNegative = []
      let locationComplianceValuesOverdueNegative = []
      let locationIdValues = []

      locationComplianceDataSorted.forEach(e => {
        locationComplianceLabels.push(e[0])
        locationComplianceValues.push(e[1].compliance)
        locationComplianceValuesDone.push(e[1].done)
        locationComplianceValuesPending.push(e[1].pending)
        locationComplianceValuesOverdue.push(e[1].overdue)
        locationComplianceValuesPendingNegative.push(-1 * e[1].pending)
        locationComplianceValuesOverdueNegative.push(-1 * e[1].overdue)
        locationIdValues.push(e[1].id)
      })

      locationCompliance.value = {
        labels: locationComplianceLabels,
        data: {
          compliance: locationComplianceValues,
          done: locationComplianceValuesDone,
          pending: locationComplianceValuesPending,
          overdue: locationComplianceValuesOverdue,
        },
        additionalInfo: {
          locationIds: locationIdValues,
        }
      };

      // Set process compliance data
      for (const process in _processCompliance) {
        _processCompliance[process].total = _processCompliance[process].done + _processCompliance[process].pending + _processCompliance[process].overdue
        _processCompliance[process].compliance = _processCompliance[process].total ? Math.round(_processCompliance[process].done / _processCompliance[process].total * 1000) / 10 : 0
      }

      let processComplianceDataSorted = Object.entries(_processCompliance)

      processComplianceDataSorted.sort(function (a, b) {
        if (b[1].compliance === 0 && a[1].compliance === 0) return a[1].total - b[1].total
        return b[1].compliance - a[1].compliance
      })

      let processComplianceLabels = []
      let processComplianceValues = []
      let processComplianceValuesDone = []
      let processComplianceValuesPending = []
      let processComplianceValuesOverdue = []
      let processIdValues = []

      processComplianceDataSorted.forEach(e => {
        processComplianceLabels.push(e[0])
        processComplianceValues.push(e[1].compliance)
        processComplianceValuesDone.push(e[1].done)
        processComplianceValuesPending.push(e[1].pending)
        processComplianceValuesOverdue.push(e[1].overdue)
        processIdValues.push(e[1].id)
      })

      processCompliance.value = {
        labels: processComplianceLabels,
        data: {
          compliance: processComplianceValues,
          done: processComplianceValuesDone,
          pending: processComplianceValuesPending,
          overdue: processComplianceValuesOverdue,
        },
        additionalInfo: {
          processIds: processIdValues,
        }
      };

      // Set global compliance data
      globalCompliance.value = {
        labels: locationComplianceLabels,
        done: locationComplianceValuesDone,
        pending: locationComplianceValuesPendingNegative,
        overdue: locationComplianceValuesOverdueNegative,
      };
    }

    function updateSupervisorData(object, name, locations, status, physicalLocations) {
      if (!object[name]) {
        object[name] = {
          location: locations,
          physicalLocations: physicalLocations,
          Realizadas: 0,
          Vencidas: 0,
          Pendientes: 0,
          Observadas: 0,
        };
      }

      if (status === "Realizadas") {
        object[name]["Realizadas"] += 1;
      } else if (status === "Pendientes") {
        object[name]["Pendientes"] += 1;
      } else if (status === "Vencidas") {
        object[name]["Vencidas"] += 1;
      } else if (status === "Observadas") {
        object[name]["Observadas"] += 1;
      }
    }

    function compliance(supervisor) {
      const total = supervisor.Realizadas + supervisor.Vencidas + supervisor.Pendientes;
      if (!total) return "N/A"
      const ratio = (supervisor.Realizadas / total) * 100;

      return `${ratio.toFixed(1)}%`;
    }

    function stripHtmlTags(htmlString) {
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = htmlString
      return tempDiv.textContent || tempDiv.innerText || ''
    }

    function updateFilter(data) {
      // Ensure all filter values are arrays
      locationFilter.value = Array.isArray(data.locationFilter) ? data.locationFilter : [];
      physicalLocationFilter.value = Array.isArray(data.physicalLocationFilter) ? data.physicalLocationFilter : [];
      roleFilter.value = Array.isArray(data.roleFilter) ? data.roleFilter : [];
      processFilter.value = Array.isArray(data.processFilter) ? data.processFilter : [];
      supervisorFilter.value = Array.isArray(data.supervisorFilter) ? data.supervisorFilter : [];
      dateRangeFilter.value = data.dateRangeFilter;
      zoneFilter.value = Array.isArray(data.zoneFilter) ? data.zoneFilter : [];
      agencyFilter.value = Array.isArray(data.agencyFilter) ? data.agencyFilter : [];

      listConfirmations();
    }

    function updateSupervisors(data) {
      if (!supervisorsDropdown.value.length && Array.isArray(data)) {
        supervisorsDropdown.value = data;
        listConfirmations();
      }
    }

    onMounted(() => {
      listConfirmations()
    })

    return {
      confirmations,
      supervisors,
      compliance,
      trackerData,
      locationCompliance,
      processCompliance,
      globalCompliance,
      progressCompliance,
      updateFilter,
      updateSupervisors,
      confirmationFields,
      supervisorFields,
      isLoading,
      qEvents,
      zone_agency_filter,
      deletedEvents,
      deletedEventsFields,
      colors
    };
  },
};
</script>
